exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.avatar-uploader[data-v-292dd544]{\n  margin-bottom: 14px;\n}\n", ""]);

// exports
